
import { defineComponent, ref } from 'vue';

import TheDetailPageHeader from '@/components/organisms/detailPage/TheDetailPageHeader.vue';
import TheDetailPageBody from '@/components/organisms/detailPage/TheDetailPageBody.vue';
import Heading from '@/components/atoms/Heading.vue';
import SignalText from '@/components/atoms/SignalText.vue';
import { memberExpression } from '@babel/types';

export default defineComponent({
  name: 'FaqContactTemplate',
  components: {
    TheDetailPageHeader,
    TheDetailPageBody,
    Heading,
    SignalText,
  },
  data() {
    return {
      mainStaff: [
        {
          label_ja: '主催',
          label_en: 'Host Organization',
          member: [
            {
              name_ja: 'JMoF実行委員会',
              name_en: 'JMoF Executive Committee',
              icon: ref().value = require('@/assets/images/icons/jmof.png'),
              web: 'https://www.jmof.jp/',
            },
          ],
        },
        {
          label_ja: 'メインスタッフ',
          label_en: 'Main Staff',
          member: [
            {
              name_ja: 'Gentou',
              name_en: 'Gentou',
              icon: ref().value = require('@/assets/images/icons/gentou.jpg'),
              twitter: 'https://twitter.com/gen_tou',
            },
            {
              name_ja: 'すみた',
              name_en: 'Sumita',
              icon: ref().value = require('@/assets/images/icons/sumita.jpg'),
              twitter: 'https://twitter.com/alcoholic_wolf',
            },
            {
              name_ja: '黒鳥',
              name_en: 'kurotori',
              icon: ref().value = require('@/assets/images/icons/kurotori.png'),
              booth: 'https://kurotori.booth.pm/',
              twitter: 'https://twitter.com/kurotori4423',
            },
            {
              name_ja: 'いなぷ',
              name_en: 'Inapu',
              icon: ref().value = require('@/assets/images/icons/inapu.png'),
              twitter: 'https://twitter.com/reo_inoko',
            },
            {
              name_ja: 'いぇし',
              name_en: 'Yeshi',
              icon: ref().value = require('@/assets/images/icons/yeshi.jpg'),
              twitter: 'https://twitter.com/Yeshi_hobby',
            },
            {
              name_ja: 'うりいぬ',
              name_en: 'URI_dog',
              icon: ref().value = require('@/assets/images/icons/uri_dog.jpg'),
              twitter: 'https://twitter.com/uriwinu',
            },
            {
              name_ja: 'あむ',
              name_en: 'Rabbuttz',
              icon: ref().value = require('@/assets/images/icons/rabbuttz.jpg'),
              twitter: 'https://twitter.com/Rabbuttz_VR',
            },
            {
              name_ja: '誰五味',
              name_en: 'Suigomi',
              icon: ref().value = require('@/assets/images/icons/suigomi.jpg'),
              booth: 'https://dareka53.booth.pm/',
              twitter: 'https://twitter.com/dareka53',
            },
          ],
        },
      ],
      subStaff: [
        {
          label_ja: '会場',
          label_en: 'Venue',
          member: [
            {
              name_ja: 'ロワジールホテル豊橋',
              name_en: 'Loisir Hotel Toyohashi',
              icon: ref().value = require('@/assets/images/icons/loisirhoteltoyohashi.png'),
              web: 'https://www.loisir-toyohashi.com/',
            },
          ],
        },
        {
          label_ja: 'VRChat ワールド・アセット制作',
          label_en: 'VRChat World / Asset Creator',
          member: [
            {
              name_ja: 'ねこのいる工房（UNIUNI）',
              name_en: 'UNIUNI',
              icon: ref().value = require('@/assets/images/icons/uniuni.jpg'),
              booth: 'https://uniunishop.booth.pm/',
              twitter: 'https://twitter.com/lept_on',
            },
            {
              name_ja: 'はい',
              name_en: 'hy',
              icon: ref().value = require('@/assets/images/icons/hy.jpg'),
              twitter: 'https://twitter.com/hd4tails',
            },
            {
              name_ja: '仮想狐のデザイン工房（るら）',
              name_en: 'VirtualFoxDesignStudio (Lura)',
              icon: ref().value = require('@/assets/images/icons/lura.jpg'),
              twitter: 'https://twitter.com/Lu_Ra_999',
            },
          ],
        },
        {
          label_ja: 'NeosVR チーム',
          label_en: 'NeosVR Team',
          member: [
            {
              name_ja: 'うすたび',
              name_en: 'usutabi',
              icon: ref().value = require('@/assets/images/icons/usutabi.jpg'),
              twitter: 'https://twitter.com/usutabi',
            },
            {
              name_ja: 'オレンジ',
              name_en: 'Orange',
              icon: ref().value = require('@/assets/images/icons/orange.jpg'),
              booth: 'https://orange3134.booth.pm/',
              twitter: 'https://twitter.com/orange_3134',
              youtube: 'https://www.youtube.com/c/ORANGEchannelO',
            },
            {
              name_ja: '駒芝',
              name_en: 'Komashiba',
              icon: ref().value = require('@/assets/images/icons/komashiba.jpg'),
              booth: 'https://koma-lab.booth.pm/',
              twitter: 'https://twitter.com/komashiba33',
            },
            {
              name_ja: 'ゴンタサン',
              name_en: 'GONT_3',
              icon: ref().value = require('@/assets/images/icons/gont_3.jpg'),
              twitter: 'https://twitter.com/nvrttxb777',
            },
            {
              name_ja: 'すら',
              name_en: 'SLA',
              icon: ref().value = require('@/assets/images/icons/sla.jpg'),
              twitter: 'https://twitter.com/_SLAVR00_',
            },
            {
              name_ja: 'ととがんま',
              name_en: 'totegamma',
              icon: ref().value = require('@/assets/images/icons/totegamma.jpg'),
              twitter: 'https://twitter.com/totegamma',
              web: 'https://gammalab.net',
            },
            {
              name_ja: 'ナボリスク',
              name_en: 'Naborisk',
              icon: ref().value = require('@/assets/images/icons/naborisk.jpg'),
              twitter: 'https://twitter.com/Naborisk1',
              web: 'https://naborisk.com',
            },
            {
              name_ja: 'ねむのみ',
              name_en: 'Nemnomi',
              icon: ref().value = require('@/assets/images/icons/nemnomi.png'),
              twitter: 'https://twitter.com/pluser',
            },
            {
              name_ja: '英 涼太',
              name_en: 'Ryota Hanabusa',
              icon: ref().value = require('@/assets/images/icons/ryota_hanabusa.jpg'),
              twitter: 'https://twitter.com/ryotahanabusa',
            },
            {
              name_ja: 'モトメイド',
              name_en: 'MotoMaid',
              icon: ref().value = require('@/assets/images/icons/motomaid.jpg'),
              twitter: 'https://twitter.com/moto_made',
            },
            {
              name_ja: 'れにうむ',
              name_en: 'rhenium',
              icon: ref().value = require('@/assets/images/icons/rhenium.jpg'),
              booth: 'https://r75.booth.pm/',
              twitter: 'https://twitter.com/rhenium_nv',
            },
            {
              name_ja: 'べるネ',
              name_en: 'berne',
              icon: ref().value = require('@/assets/images/icons/berne.png'),
              twitter: 'https://twitter.com/bernenoky',
            },
          ],
        },
        {
          label_ja: '過去のスタッフ・協力者',
          label_en: 'Our Friends Who Helped Us',
          member: [
            {
              name_ja: 'ぎがすけ商会（gigash）',
              name_en: 'Gigasuke Shokai (gigash)',
              icon: ref().value = require('@/assets/images/icons/gigash.jpg'),
              booth: 'https://gigasuke-shokai.booth.pm/',
              twitter: 'https://twitter.com/gigash',
            },
            {
              name_ja: 'ひるね小屋（睡犬）',
              name_en: 'Hirune House (suiken)',
              icon: ref().value = require('@/assets/images/icons/cwwdog.jpg'),
              booth: 'https://cwwdog.booth.pm/',
            },
            {
              name_ja: '株式会社みるくぽっと',
              name_en: 'Milkpot Co.,Ltd.',
              icon: ref().value = require('@/assets/images/icons/milkpot.png'),
            },
            {
              name_ja: '四つ足カルテット',
              name_en: 'quadruped quartet',
              icon: ref().value = require('@/assets/images/icons/quadruped.png'),
              booth: 'https://quadruped.booth.pm/',
            },
            {
              name_ja: 'Kemonap',
              name_en: 'Kemonap',
              icon: ref().value = require('@/assets/images/icons/kemonap.jpg'),
              booth: 'https://kemonap.booth.pm/',
              twitter: 'https://twitter.com/Kemonap_',
            },
            {
              name_ja: 'Anagura Works（やまかみ）',
              name_en: 'Anagura Works (Yamakami)',
              icon: ref().value = require('@/assets/images/icons/yamakami.jpg'),
              booth: 'https://anaguraworks.booth.pm',
              twitter: 'https://twitter.com/yamakami_gm',
            },
            {
              name_ja: 'KEMO CLUB',
              name_en: 'KEMO CLUB',
              icon: ref().value = require('@/assets/images/icons/kemoclub.png'),
            },
            {
              name_ja: 'nennnn',
              name_en: 'nennnn',
              icon: ref().value = require('@/assets/images/icons/nennnn.jpg'),
              twitter: 'https://twitter.com/nennnn4',
            },
            {
              name_ja: 'Giwa',
              name_en: 'Giwa',
              icon: ref().value = require('@/assets/images/icons/giwa.jpg'),
              twitter: 'https://twitter.com/G1wa_',
            },
          ],
        },
      ],
    };
  },
  props: {
    i18n: {
      type: Object,
    },
  },
});
